export enum SystemTypeEnum {
  SYSTEM = 'SISTEMA',
  APPLICATION = 'APLICAÇÃO',
  ACCOUNTING = 'CONTABIL',
  CONSULTANCY = 'CONSULTORIA',
  MARKETING = 'MARKETING',
  REVENDA = 'REVENDA',
  CLOUD = 'CLOUD',
  SERVICES = 'SERVIÇOS',
  BACKUP = 'BACKUP'
}

export enum SystemTypeIdEnum {
  'SISTEMA' = 1,
  'APLICAÇÃO' = 2,
  'CONTABIL' = 3,
  'CONSULTORIA' = 4,
  'MARKETING' = 5,
  'REVENDA' = 6,
  'CLOUD' = 7,
  'SERVIÇOS' = 8,
  'BACKUP' = 9,
}

export enum SystemDueDateEnum {
  DUE_DATE_5 = 5,
  DUE_DATE_10 = 10,
  DUE_DATE_15 = 15,
  DUE_DATE_20 = 20,
  DUE_DATE_28 = 28
}

export enum SystemDueDateIdEnum {
  'five' = 1,
  'ten' = 2,
  'fifteen' = 3,
  'twenty' = 4,
  'twentyEight' = 5,
}

export enum DefaultFilterLabels {
  ALL_TYPES = 'TODOS OS TIPOS',
  ALL_DATES = 'TODAS AS DATAS'
}

export interface ISystemTypeOption {
  value: number | null;
  label: string;
}

export function getSystemTypeDescriptionByValue(value: number): string {
  const entries = Object.entries(SystemTypeIdEnum);
  const entry = entries.find(([_, enumValue]) => enumValue === value);

  return entry ? entry[0] : '';
}

export function createSystemTypeOptions(): ISystemTypeOption[] {
  const defaultOption: ISystemTypeOption = {
    value: null,
    label: DefaultFilterLabels.ALL_TYPES
  };

  const options = Object.entries(SystemTypeIdEnum)
    .filter(([key, value]) => typeof value === 'number')
    .map(([key, value]) => ({
      value: value as number,
      label: key
    }));

  return [defaultOption, ...options];
}

export function createDueDateOptions(): ISystemTypeOption[] {
  const defaultOption: ISystemTypeOption = {
    value: null,
    label: DefaultFilterLabels.ALL_DATES
  };

  const options = Object.entries(SystemDueDateEnum)
    .filter(([key, value]) => typeof value === 'number')
    .map(([key, value]) => ({
      value: value as number,
      label: String(value)
    }));

  return [defaultOption, ...options];
}


